import React from "react";
import { useTranslation } from "react-i18next";

const KPIChartSortHeader = ({ fields = [], sortBy, sortDirection, onSortChange }) => {
  const { t } = useTranslation();

  const handleSort = key => {
    if (sortBy === key) {
      onSortChange(key, sortDirection === "asc" ? "desc" : "asc");
    } else {
      onSortChange(key, "asc");
    }
  }


  return (
      <table className="kpi-sort-header table is-fullwidth mb-4">
        <thead>
        <tr>
          {fields.map(field => (
              <th
                  key={field.key}
                  className={"is-clickable" +
                    "has-text-weight-bold" + (sortBy === field.key)
                  }
                  onClick={() => handleSort(field.key)}
              >
                {t(field.labelKey)}
                {sortBy === field.key && (
                    <span> {sortDirection === "asc" ? "↑" : "↓"}</span>
                )}
              </th>
          ))}
        </tr>
        </thead>
      </table>
  );
};

export default KPIChartSortHeader;
